import * as React from 'react';
import {useRef} from 'react';
import {useIntl} from 'react-intl';
import {Messages} from 'primereact/messages';
import {useMountEffect} from 'primereact/hooks';


interface Props {
    invoice: any
    selectedInvoices: string[]
}

export const SelectedInvoices: React.FC<Props> = ({ invoice, selectedInvoices }) => {
    const { formatMessage: f } = useIntl();
    const msgs = useRef<Messages>(null);
    
    const details = f({ id: 'penaltyPaymentDescription' });

    useMountEffect(() => {
        if (msgs.current) {
            msgs.current?.clear();
            msgs.current.show([
                { sticky: true, severity: 'info', detail: details, closable: false },
            ]);
        }
    });




    return (
        <div>
            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", flexWrap: "wrap", alignContent: "center", marginBottom: "20px" }}>
                <label style={{ marginRight: "4px" }}><strong>{f({ id: 'settlementOfInvoicePenalties' })}</strong></label>

                {selectedInvoices.length == 0 && (
                    <label style={{ marginRight: "4px", color: "#00b4fb" }}><strong>{f({ id: 'fullSettlement' })}</strong></label>
                )}

                {selectedInvoices.length > 0 && invoice?.rows && invoice.rows.map((i: any, index: number) => (
                    <>
                        {i.penalty > 0 ? (
                            <div key={index} style={{ marginRight: "4px", padding: "3px", backgroundColor: "#E0A706", color: "black", borderRadius: "8px" }}>
                                <strong>{i.invoiceNumber}</strong>
                            </div>
                        ) : null}

                    </>
                ))}
            </div>

            <div>
                <strong>{f({ id: 'totalForSettlement' })}</strong>
                <label style={{ marginLeft: "4px", paddingTop: "3px", color: "#00b4fb" }}>
                    <strong>{(invoice.subtotals.penaltiesAmount).toFixed(2)} €</strong>
                </label>

                <Messages style={{ maxWidth: "80rem", display: "flex", alignContent: "center" }} ref={msgs} />

            </div>
        </div>
    );
}

export default SelectedInvoices;
